import styled from '@emotion/styled'

import { theme } from '../../constants/theme'

export const ArrowIcon = styled.div<{ isOpen: boolean }>(({ isOpen }) => ({
  appearance: 'none',
  backgroundImage:
    'url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+CiAgICA8cGF0aCBkPSJNMjQgMjRIMFYwaDI0djI0eiIgZmlsbD0ibm9uZSIgb3BhY2l0eT0iLjg3IiAvPgogICAgPHBhdGggZD0iTTE2LjU5IDguNTlMMTIgMTMuMTcgNy40MSA4LjU5IDYgMTBsNiA2IDYtNi0xLjQxLTEuNDF6IiAvPgo8L3N2Zz4=)',
  backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  height: 24,
  marginRight: 12,
  transform: isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: theme.animation.transition,
  width: 12,
}))
